import { api, unwrap } from "@/lib/api";

export interface AdsStatus {
	enabled: boolean;
	catalogReady: boolean;
	/** Devise ISO du compte pub (ex. USD, XAF) ; null si non configuré. */
	currency?: string | null;
}

export interface CampaignSummary {
	id: string;
	name: string;
	status: string;
	effectiveStatus?: string;
	objective?: string;
	dailyBudget?: number | null;
	insights?: {
		spend?: number;
		impressions?: number;
		reach?: number;
		clicks?: number;
		purchases?: number;
		roas?: number;
	};
}

export interface CreateCatalogCampaignInput {
	name: string;
	dailyBudget: number;
	audience: "retargeting" | "prospecting";
	countries?: string[];
}

export const adsApi = {
	status: () => unwrap<AdsStatus>(api.get("/admin/ads/status")),
	campaigns: () => unwrap<CampaignSummary[]>(api.get("/admin/ads/campaigns")),
	createCatalog: (dto: CreateCatalogCampaignInput) =>
		unwrap<{
			ok: boolean;
			data: { campaignId: string } | null;
			error?: string;
		}>(api.post("/admin/ads/campaigns/catalog", dto)),
	setStatus: (id: string, status: "ACTIVE" | "PAUSED") =>
		unwrap<{ ok: boolean; error?: string }>(
			api.post(`/admin/ads/campaigns/${id}/status`, { status }),
		),
};
